import { SERVICE } from './constants'

export const SHOW = `${SERVICE}/SHOW`
export const HIDE = `${SERVICE}/HIDE`
export const SET_DATA = `${SERVICE}/SET_DATA`
export const RESET_DATA = `${SERVICE}/RESET_DATA`
